<template>
    
<div>

    <page-padding>
     
        <spinner v-if="showLoader && !hasDocuments" class="spinner-custom" />
        <div v-if="!showLoader && !hasDocuments">{{$t('language.no_documents')}}</div>
        <div v-if="hasDocuments">
         
         <div>
          <featured-button :key="index" v-for='(item,index) in sliceArray(documents["0documents"],3)' iconRight="file-download" :title="item.title" :subtitle="item.descr" @click.native="viewPdf(item)"/>
         </div>
          <button-more title="language.view_more_documents" to="/documents"/>
        </div>
      </page-padding>

</div>
</template>

<script>

import { mapState } from 'vuex';
import PagePadding from '../../components/PagePadding';
import Spinner from '../../components/Spinner';
import ButtonMore from '../../components/buttons/ButtonMore';
import FeaturedButton from '../../components/buttons/FeaturedButton';

import { fileSave } from '../../services/FileSave.js';

export default {
  name: 'list-documents-featured',
  props:{
  },
  data:function(){
    return {
      showLoader:false,
    }
  },
  components:{
    PagePadding,
    Spinner,
    ButtonMore,
    FeaturedButton,
  },
  methods:{
    viewPdf(item){
      
      this.$store.dispatch('get_crossdomain_download',{dwnl_id:item.id,cat_id:item.cat_id}).then(
        result=>{
          var base64data= "data:application/pdf;base64,"+result.data.base64Data;
          fileSave.saveBase64ToFile(base64data, item.title);
        })
       

    },
    sliceArray(arr,count){
      if(arr){
        return arr.slice(0,count)
      }else{
        return [];
      }
    }
  },
  computed:{
    ...mapState([
       'documents','loaded'
       ]),
       hasDocuments:function(){
         if(this.documents["0documents"]){
           return this.documents["0documents"] ? this.documents["0documents"].length : false;
         }else{
           return false;
         }
       }
  },
  created:function(){
    this.showLoader=true;
    this.$store.dispatch('get_documents',{store_key:"0documents",id:0}).then(()=>{
       this.showLoader=false;
    })
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.heading{
  background-color:#EEEEEE;
  padding:5px;
  margin-bottom:15px;
  border-radius:4px;
}
.calendar-item{
  margin-bottom:25px;
}
.spinner-custom{
  margin:10px 0;
}
</style>

